
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[slug]/[subSlug]",
      function () {
        return require("private-next-pages/services/[slug]/[subSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[slug]/[subSlug]"])
      });
    }
  